module.exports = __webpack_public_path__ + "static/media/down.7e907116.svg";